import React, { useState, useEffect, useCallback } from "react";
import { useQuery } from "@apollo/react-hooks";
import {
  Modal,
  Input,
  List,
  Row,
  Col,
  Button,
  Spin,
  Dropdown,
  Menu,
  Icon,
  Typography,
} from "antd";
import { QUERIES } from "../../api/queries";
import { Divider } from "antd";

const { Search } = Input;
const { Text } = Typography;

const SearchEmployee = ({
  visible: initialVisible = true,
  onClose,
  onSelect,
  name,
}) => {
  const [visible, setVisible] = useState(initialVisible);
  const [employees, setEmployees] = useState([]);
  const [inputValue, setInputValue] = useState(name || "");
  const [searchTerm, setSearchTerm] = useState(null);

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [bikeModalVisible, setBikeModalVisible] = useState(false);

  // Apollo query (SAFE)
  const { loading, data, error, refetch } = useQuery(
    QUERIES.EMPLOYEE_FOR_SERVICE_PASS,
    {
      searchTerm,
      skip: !searchTerm,
      fetchPolicy: "network-only",
    }
  );

  // Handle query result safely
  useEffect(() => {
    if (!data || !data.searchEmployees) {
      setEmployees([]);
      return;
    }

    const filtered = data.searchEmployees.filter(
      (el) => el.bike && el.bike.length > 0
    );

    setEmployees(filtered);
  }, [data]);

  // Close handling
  useEffect(() => {
    if (!visible) {
      onClose && onClose();
    }
  }, [visible, onClose]);

  // Explicit search trigger
  const handleSearch = (value) => {
    if (!value || value.trim().length < 3) {
      return; // ❌ do nothing if < 3 chars
    }

    setSearchTerm(value);
    refetch({ search: value });
  };

  // Bike dropdown menu
  const bikeMenu = (
    <Menu>
      <Menu.Item disabled>
        <b>ID – Merk</b>
      </Menu.Item>
      {selectedEmployee &&
        selectedEmployee.bike.map((b) => (
          <Menu.Item
            key={b.id}
            onClick={() => {
              onSelect({ employee: selectedEmployee, bike: b });
              setBikeModalVisible(false);
              setVisible(false);
            }}
          >
            {"Q" + b.order.quotation_fk + " – " + b.bikeBrand.name}
          </Menu.Item>
        ))}
    </Menu>
  );

  return (
    <Modal
      visible={visible}
      title="Zoek werknemer"
      footer={null}
      width={600}
      onCancel={() => setVisible(false)}
      destroyOnClose
    >
      {/* Search input */}
      <Search
        value={inputValue}
        placeholder="Zoek op naam (min. 3 tekens)"
        onChange={(e) => setInputValue(e.target.value)}
        onSearch={handleSearch}
        enterButton
        style={{ marginBottom: 16 }}
      />

      {/* Error state */}
      {error && (
        <Text type="danger">
          Er ging iets mis bij het laden van medewerkers.
        </Text>
      )}

      {/* Employee list */}
      <List
        loading={loading}
        locale={{ emptyText: "Geen resultaten" }}
        dataSource={employees}
        renderItem={(el) => (
          <List.Item>
            <List.Item.Meta
              title={
                <Text strong>
                  {el.first_name} {el.last_name}
                </Text>
              }
              description={
                <Row type="flex" justify="space-between" align="middle">
                  <Col>
                    <Text type="secondary">{el.company.name}</Text>
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      shape="circle"
                      onClick={() => {
                        if (el.bike.length > 1) {
                          setSelectedEmployee(el);
                          setBikeModalVisible(true);
                        } else {
                          onSelect({
                            employee: el,
                            bike: el.bike[0],
                          });
                          setVisible(false);
                        }
                      }}
                    >
                      <Icon type="check" />
                    </Button>
                  </Col>
                </Row>
              }
            />
          </List.Item>
        )}
      />

      {/* Unlinked option */}
      {searchTerm && (
        <>
          <Divider style={{ margin: "12px 0" }} />

          <List.Item>
            <List.Item.Meta
              title={<Text strong>{searchTerm}</Text>}
              description={
                <Row type="flex" justify="space-between" align="middle">
                  <Col>
                    <Text type="secondary">Ongelinkt</Text>
                  </Col>
                  <Col>
                    <Button
                      shape="circle"
                      onClick={() => {
                        onSelect({ employeeName: searchTerm, employee: null });
                        setVisible(false);
                      }}
                    >
                      <Icon type="check" />
                    </Button>
                  </Col>
                </Row>
              }
            />
          </List.Item>
        </>
      )}

      {/* Bike selection modal */}
      <Modal
        visible={bikeModalVisible}
        title="Meerdere fietsen gevonden"
        footer={null}
        onCancel={() => setBikeModalVisible(false)}
        destroyOnClose
      >
        {!selectedEmployee ? (
          <Spin />
        ) : (
          <Dropdown overlay={bikeMenu} trigger={["click"]}>
            <Button block>
              Fiets kiezen <Icon type="down" />
            </Button>
          </Dropdown>
        )}
      </Modal>
    </Modal>
  );
};

export default SearchEmployee;
